<!--销售订单收款电商版 -->
<template>
    <div v-loading="loading">
        <el-form :rules="rules" :model="submitData" label-width="80px" ref="submitData">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="grid-content bg-purple">
                        <el-form-item label="销售总额">
                            <el-input v-model="submitData.OrderAmount" disabled="disabled"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content bg-purple">
                        <el-form-item label="应收总额">
                            <el-input v-model="submitData.CalcAmount" disabled="disabled"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content bg-purple">
                        <el-form-item label="实收金额" prop="CollectionAmount">
                            <el-input v-model="submitData.CollectionAmount" :disabled="isCanEdit"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="grid-content bg-purple">
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select v-model="submitData.PayType" placeholder="请选择" style="width: 100%"
                                :disabled="isCanEdit">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text"
                                    :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="grid-content bg-purple">
                        <el-form-item label="备注">
                            <el-input v-model="submitData.Remark" :disabled="isCanEdit"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <div>
            <el-row :gutter="20">
                <el-col :span="18">
                    <div class="form-uploadImg">
                        <div>上传流水单据</div>
                        <el-upload action="#" :file-list="orderImages" list-type="picture-card"
                            accept="image/jpeg, image/png" :on-preview="onUploadPreview" :on-remove="onUploadRemove"
                            :before-remove="beforeRemove" :http-request="handleLocalUpload">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogImageVisible" append-to-body>
                            <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn btn-primary" @click="submitForm()">确认收款</el-button>
            <el-button size="small" class="search-btn" @click="cancel()">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        orderData: { type: Object },
        orderType: { type: Number }
    },
    components: {},
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            userMsg: userMsg,
            orderImages: [],
            tempFile: [],
            uploadImgData: [],
            uploadImgUrl: this.$util.BASE_URL + '/EntpSaleOrder/AddOrderImage',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            dialogImageUrl: '',
            uploadImgFile: null,
            dialogImageVisible: false,
            isCanEdit: true,
            payDataCount: 0,
            waitPay: 0,
            payWayList: [],
            submitData: {
                EntpCusOId: '',
                OrderType:0,
                OrderAmount: 0,
                CollectionAmount: 0,
                CalcAmount: 0,
                PayType: '',
                Remark: '',
                PictureList:[]
            },
            rules: {
                PayType: [{ required: true, message: '该项必填', trigger: 'change' }],
                CollectionAmount: [{ required: true, message: '该项必填', trigger: 'change' }]
            },
            PayType: "",
        };
    },
    mounted() {
        this.getOrderDetails();
        this.submitData.OrderType = this.orderType;
    },
    beforeDestroy() {
        //注销粘贴事件
        // document.removeEventListener('paste', this.handlePaste, false);
    },
    methods: {
        cancel() {
            //注销粘贴事件
            // document.removeEventListener('paste', this.handlePaste, false);
            this.$emit('closeReceipt');
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
                this.submitData.PayType = this.PayType;
            });
        },
        getOrderDetails() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_EC/GetPayOrderInfoById',
                    data: {
                        OrderId: this.orderData.EntpCusOId,
                        Type: this.orderType
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;

                    this.submitData.OrderAmount = data.OrderAmount;

                    this.submitData.Remark = '';
                    this.submitData.EntpCusOId = data.EntpCusOId;
                    this.PayType = data.PayType;

                    this.submitData.CalcAmount = data.CalcAmount;
                    this.submitData.CollectionAmount = data.CalcAmount;
                    this.isCanEdit = data.IsPay;

                    // this.orderImages = data.OrderImages;
                    // for (let j = 0; j < this.orderImages.length; j++) {
                    //     this.orderImages[j].name = this.orderImages[j].Id;
                    //     this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    //     this.submitData.PictureList.push(this.orderImages[j].ImgUrl);
                    // }
                    this.loading = false;
                    this.getPay();

                    // if (this.isCanEdit) {
                    //     this.$nextTick(() => {
                    //         //注册粘贴事件
                    //         document.addEventListener('paste', this.handlePaste, false);
                    //     });
                    // }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        submitForm() {
            // if (this.submitData.CollectionAmount <= 0) {
            //     this.$util.warningMsg('申请收款金额必须大于0');

            //     return;
            // }
            if (parseFloat(this.submitData.CalcAmount) != 0 && parseFloat(this.submitData.CollectionAmount) == 0) {
                this.$confirm('当前实收金额为0，与销售应收金额不等，是否确认收款？', '提示', {
                    confirmButtonText: '确定继续申请',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$refs['submitData'].validate(valid => {
                            if (valid) {
                                if (this.tempFile.length > 0) {
                                    this.startUploading().then(res => {
                                        this.loading = true;
                                        this.$util
                                            .axiosPost({
                                                url: '/api/RevenueManagement_EC/ApplyCollection',
                                                data: this.submitData
                                            })
                                            .then(res => {
                                                this.$util.successMsg('单据已确认收款');
                                                this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                            })
                                            .catch(() => {
                                                this.loading = false;
                                            });
                                    });
                                }else{
                                    this.loading = true;
                                        this.$util
                                            .axiosPost({
                                                url: '/api/RevenueManagement_EC/ApplyCollection',
                                                data: this.submitData
                                            })
                                            .then(res => {
                                                this.$util.successMsg('单据已确认收款');
                                                this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                            })
                                            .catch(() => {
                                                this.loading = false;
                                            });
                                }
                            } else {
                                return false;
                            }
                        });
                    })
                    .catch(() => { });
            } else if (parseFloat(this.submitData.CollectionAmount) != parseFloat(this.submitData.CalcAmount)) {
                this.$confirm('收款金额已超过或小于待收款金额，是否继续申请？', '提示', {
                    confirmButtonText: '确定继续申请',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.$refs['submitData'].validate(valid => {
                            if (valid) {
                                if (this.tempFile.length > 0) {
                                    this.startUploading().then(res => {
                                        this.loading = true;
                                        this.$util
                                            .axiosPost({
                                                url: '/api/RevenueManagement_EC/ApplyCollection',
                                                data: this.submitData
                                            })
                                            .then(res => {
                                                this.$util.successMsg('单据已确认收款');
                                                this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                            })
                                            .catch(() => {
                                                this.loading = false;
                                            });
                                    });
                                }else{
                                    this.loading = true;
                                        this.$util
                                            .axiosPost({
                                                url: '/api/RevenueManagement_EC/ApplyCollection',
                                                data: this.submitData
                                            })
                                            .then(res => {
                                                this.$util.successMsg('单据已确认收款');
                                                this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                            })
                                            .catch(() => {
                                                this.loading = false;
                                            });
                                }
                            } else {
                                return false;
                            }
                        });
                    })
                    .catch(() => { });
            } else{
                this.$refs['submitData'].validate(valid => {
                    if (valid) {
                        if (this.tempFile.length > 0) {
                            this.startUploading().then(res => {
                                this.loading = true;
                                this.$util
                                    .axiosPost({
                                        url: '/api/RevenueManagement_EC/ApplyCollection',
                                        data: this.submitData
                                    })
                                    .then(res => {
                                        if(res.errcode == 0){
                                            this.$util.successMsg('单据已确认收款');
                                            this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                        }else
                                            this.$util.errorMsg(res.errorMsg);
                                    })
                                    .catch(() => {
                                        this.loading = false;
                                    });
                            });
                        }else{
                            this.loading = true;
                            this.$util
                                .axiosPost({
                                    url: '/api/RevenueManagement_EC/ApplyCollection',
                                    data: this.submitData
                                })
                                .then(res => {
                                    if(res.errcode == 0){
                                        this.$util.successMsg('单据已确认收款');
                                        this.$emit('closeReceipt',this.submitData.EntpCusOId,this.submitData.OrderType);
                                    }else
                                        this.$util.errorMsg(res.errorMsg);
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        beforeRemove(file, fileList) {
        },
        onUploadRemove(file) {
            var index = this.uploadImgData.findIndex(x => x.name == file.name);
            if(index > -1) this.uploadImgData.splice(index, 1);

            index = this.submitData.PictureList.findIndex(x => x == file.ImgUrl);
            if(index > -1) this.submitData.PictureList.splice(index, 1);

        },
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        handleLocalUpload(options) {
            let that = this;
            const file = options.file; // 获取选中的文件对象
            this.uploadCheck(file, that);
            this.tempFile.push(file);
        },
        uploadCheck(file, that) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';

            //改成10M
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                that.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt20M) {
                that.$util.warningMsg('上传图片大小不能超过 20MB!');
            }

            return (isJPG || isBMP || isGIF || isPNG) && isLt20M;
        },
        //开始上传
        startUploading() {
            let that = this;
            that.loading = true;
            return new Promise((resolve, reject) => {
                let fd = new window.FormData();
                for (let index = 0; index < that.tempFile.length; index++) {
                    fd.append('files', that.tempFile[index]);
                }
                fd.append('key', "OrderGatgering");
                fd.append('isPrivate', false);
                let xhr = new XMLHttpRequest();
                xhr.open('POST', '/api/UploadFile/UploadMultiple', true);

                xhr.setRequestHeader('access-key', that.token);

                xhr.onload = () => {
                    if (xhr.status === 200) {
                        let result = JSON.parse(xhr.responseText);
                        if (result.errcode == 500) {
                            that.loading = false;
                        } else {
                            for (let i = 0; i < result.length; i++) {
                                let item = JSON.parse(result[i]);
                                if (item.errcode == 0 && item && item.fileUrl) {
                                    that.submitData.PictureList.push(item.fileUrl);
                                }
                            }
                            that.loading = false;
                            resolve();
                        }
                    } else {
                        that.loading = false;
                    }
                };

                xhr.onerror = () => {
                    this.$util.errorMsg('上传失败');
                    that.loading = false;
                };
                xhr.send(fd);
            });
        },
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}

.btn-ctn {
    text-align: right;
}

.el-row {
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
